<template>
    <div class="testimonial-area testimonial-yellow horizontal" id="reviews" style = "margin-top:20px;padding-top:0">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-title text-center">
                        <h1>Clientes <span>Satisfeitos</span></h1>
                        <br />
                        <p>Saiba por que milhares de empresas utilizam o nosso sistema para alavancar sua produtividade e reduzir custos.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-lg-offset-0 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1">
                    <div class="row">
                        <div class="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2">
                            <div class="testimonial-image-slider text-center">
                                <div 
                                    v-for="(depoimento, i) in depoimentos"
                                    :key="i"
                                    class="sin-testiImage"
                                >
                                    <img 
                                        :src="'/img/site/depoimentos/' + depoimento.Depoimento.id + '/mini_' + depoimento.Depoimento.imagem" 
                                        :alt="depoimento.Depoimento.nome + ' - ' + depoimento.Depoimento.cargo" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div 
                        class="testimonial-text-slider text-center"
                    >
                        <div 
                            v-for="(depoimento, i) in depoimentos"
                            :key="i"
                            class="sin-testiText"
                        >
                            <h3>
                                {{ 
                                    depoimento.Depoimento.nome + ' - ' + depoimento.Depoimento.cargo 
                                }}
                            </h3>
                            <h4>
                                {{ 
                                    depoimento.Depoimento.empresa + ' - ' + depoimento.Depoimento.cidade 
                                }}
                            </h4>
                            <div class="client-rating">
                                <i class="zmdi zmdi-star color"></i>
                                <i class="zmdi zmdi-star color"></i>
                                <i class="zmdi zmdi-star color"></i>
                                <i class="zmdi zmdi-star color"></i>
                                <i class="zmdi zmdi-star-half color"></i>
                            </div>
                            <p>
                                {{
                                    depoimento.Depoimento.depoimento
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['depoimentos'],
}
</script>